import React from 'react';
import { CheckCircle2Icon, ShieldCheckIcon } from 'lucide-react';
import { CountdownUrgency } from './CountdownUrgency';
import { BuyButton } from './BuyButton';
import { CHECKOUT_URL } from '../data/content';
const ORDER_ITEMS = [{
  label: 'Class Generator (Excel)',
  value: 'Included'
}, {
  label: 'Pricing Calculator (Excel)',
  value: 'Included'
}, {
  label: 'Student CRM (Excel)',
  value: 'Included'
}, {
  label: 'Legal Kit (Word)',
  value: 'Included'
}, {
  label: 'Message Kit (Word)',
  value: 'Included'
}, {
  label: 'Pre-Built Class Library (Word)',
  value: 'Included'
}];
function goToCheckout() {
  window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
}
export function FinalOffer() {
  return <section id="oferta" className="scroll-mt-4 px-5 py-10" data-id="element-120" data-mp="2952nmj5i1u7w">
      <div className="mx-auto max-w-md" data-id="element-121" data-mp="295m8o8qg4yq5">
        <div className="overflow-hidden rounded-3xl border border-[var(--pb-lime)]/45 bg-[#101b2d]/98 shadow-2xl shadow-black/60" data-id="element-122" data-mp="2469jhhc3rfke">
          <div className="bg-[var(--pb-lime)] px-5 py-3 text-center" data-id="element-123" data-mp="1qi9cov1eu20">
            <p className="font-display text-lg font-800 uppercase tracking-wide text-[var(--pb-navy)]" data-id="element-124" data-mp="6o9zbdc4g63k">
              🏓 Pickleball Coach 360 Kit
            </p>
          </div>

          <div className="p-5" data-id="element-125" data-mp="bpzd30qqaxvc">
            <CountdownUrgency data-id="element-126" data-mp="gn93ailxzdk8" />

            {/* Order summary */}
            <div className="mt-5" data-id="element-127" data-mp="gkd4yt66mmv9">
              <p className="mb-3 text-xs font-700 uppercase tracking-widest text-white/70" data-id="element-128" data-mp="kp2xc81mtjbf">
                Order Summary
              </p>
              <ul className="space-y-2" data-id="element-129" data-mp="pll237wyphnr">
                {ORDER_ITEMS.map(item => <li key={item.label} className="flex items-center justify-between gap-2 text-sm" data-id="element-130" data-mp="uemhdh12zj7v">
                    <span className="flex items-start gap-2 text-white/80" data-id="element-131" data-mp="14ctutpw5vj54">
                      <CheckCircle2Icon size={15} className="mt-0.5 shrink-0 text-[var(--pb-lime)]" data-id="element-132" data-mp="18dvntozhiyyn" />
                      {item.label}
                    </span>
                    <span className="shrink-0 text-xs font-700 text-[var(--pb-lime)]" data-id="element-133" data-mp="30g85ma9t98bv">
                      {item.value}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Price */}
            <div className="mt-6 flex items-end justify-center gap-3" data-id="element-134" data-mp="3o485bzp3o92l">
              <span className="text-2xl font-600 text-white/40 line-through" data-id="element-135" data-mp="3j5wtjjf8vohq">
                $75 USD
              </span>
              <span className="font-display text-6xl font-800 leading-none text-[var(--pb-lime)]" data-id="element-136" data-mp="10l7nvq1bn0u">
                $25
              </span>
              <span className="mb-1 text-lg font-700 text-white" data-id="element-137" data-mp="3t4vsube4e7s2">USD</span>
            </div>
            <p className="mt-1 text-center text-xs text-white/70" data-id="element-138" data-mp="22s6n460nko4x">
              One-time payment · Instant access · No subscriptions
            </p>

            <div className="mt-5" data-id="element-139" data-mp="1omej7bjy6tv1">
              <BuyButton onClick={goToCheckout} data-id="element-140" data-mp="1onft3cp89ab6" />
            </div>

            <div className="mt-4 flex items-center justify-center gap-2 text-xs text-white/80" data-id="element-141" data-mp="1so9he76l0r4l">
              <ShieldCheckIcon size={14} className="text-[var(--pb-lime)]" data-id="element-142" data-mp="1ewux7x0xujvy" />
              100% secure checkout · Automatic email delivery
            </div>
          </div>
        </div>
      </div>
    </section>;
}